import { Button, FormInput, FormRoot, RHF, zodResolver } from "@devhop/ui";
import { z } from "zod";
import type {
  CatalogBrandCreateInput,
  CatalogBrandUpdateInput,
} from "@/modules/catalog/domain/contracts";

const BrandFormSchema = z.object({
  name: z.string().min(1, "ກະລຸນາໃສ່ຊື່ແບຣນດ໌"),
});

type BrandFormValues = z.infer<typeof BrandFormSchema>;

type BrandFormProps = {
  initialValues?: Partial<BrandFormValues>;
  onSubmit: (values: CatalogBrandCreateInput | CatalogBrandUpdateInput) => void;
  onCancel?: () => void;
  submitting?: boolean;
  submitLabel?: string;
};

export function BrandForm({
  initialValues,
  onSubmit,
  onCancel,
  submitting,
  submitLabel = "ບັນທຶກ",
}: BrandFormProps) {
  const methods = RHF.useForm<BrandFormValues>({
    resolver: zodResolver(BrandFormSchema),
    defaultValues: {
      name: initialValues?.name ?? "",
    },
  });

  const handleSubmit = (vals: BrandFormValues) => {
    onSubmit({ name: vals.name });
  };

  return (
    <FormRoot<BrandFormValues>
      methods={methods}
      onSubmit={handleSubmit}
      className="space-y-4"
    >
      <FormInput name="name" label="ຊື່ແບຣນດ໌" placeholder="ກະລຸນາໃສ່ຊື່" />
      <div className="flex justify-end gap-2 pt-2">
        {onCancel && (
          <Button type="button" variant="outline" onClick={onCancel}>
            ຍົກເລີກ
          </Button>
        )}
        <Button type="submit" disabled={submitting}>
          {submitLabel}
        </Button>
      </div>
    </FormRoot>
  );
}
